document.addEventListener('DOMContentLoaded', function() {
    var ul = document.querySelector(".menu-right ul");

    if( ul ){
        var children = Array.from(ul.children);

        while (ul.firstChild) {
            ul.firstChild.remove();
        }

        for (let i = 0; i < children.length; i += 3) {
            let group = children.slice(i, i + 3).reverse();
            group.forEach((child) => {
                ul.appendChild(child);
            });
        }    
    }
});